import { render, staticRenderFns } from "./TeamCards.vue?vue&type=template&id=73007530"
import script from "./TeamCards.vue?vue&type=script&lang=js"
export * from "./TeamCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports